import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import en from './locales/en.json';
import ja from './locales/ja.json';
import landingEn from './locales/landing-en.json';
import landingJa from './locales/landing-ja.json';
import landingV2En from './locales/landing-v2-en.json';
import landingV2Ja from './locales/landing-v2-ja.json';
import landingV3Ja from './locales/landing-v3-ja.json';
import landingV4Ja from './locales/landing-v4-ja.json';
import landingV5Ja from './locales/landing-v5-ja.json';
import landingV6Ja from './locales/landing-v6-ja.json';

// Detect user's language based on browser locale
export const detectLanguage = (): 'ja' | 'en' => {
  // Check if USD is enabled (if USD is enabled, force English)
  const enableUSD = import.meta.env.VITE_ENABLE_USD === 'true';

  if (enableUSD) {
    return 'en';
  }

  // Detect from browser locale
  const locale = navigator.language.toLowerCase();

  // Japanese users
  if (locale.startsWith('ja')) {
    return 'ja';
  }

  // English-speaking countries
  if (locale.startsWith('en')) {
    return 'en';
  }

  // Default to Japanese (for Japanese service)
  return 'ja';
};

// Deep merge helper for nested objects
const deepMerge = (target: any, source: any): any => {
  const output = { ...target };
  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(key => {
      if (isObject(source[key])) {
        if (!(key in target)) {
          output[key] = source[key];
        } else {
          output[key] = deepMerge(target[key], source[key]);
        }
      } else {
        output[key] = source[key];
      }
    });
  }
  return output;
};

const isObject = (item: any): boolean => {
  return item && typeof item === 'object' && !Array.isArray(item);
};

// Merge landing translations properly with deep merge
const mergeTranslations = (base: any, landing: any) => {
  return {
    ...base,
    landing: deepMerge(base.landing || {}, landing.landing || {})
  };
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: mergeTranslations(en, landingEn),
        'landing-v2': landingV2En,
        'landing-v3': landingV3Ja, // 英語版がないため日本語をフォールバック
        'landing-v4': landingV4Ja,
        'landing-v5': landingV5Ja,
        'landing-v6': landingV6Ja
      },
      ja: {
        translation: mergeTranslations(ja, landingJa),
        'landing-v2': landingV2Ja,
        'landing-v3': landingV3Ja,
        'landing-v4': landingV4Ja,
        'landing-v5': landingV5Ja,
        'landing-v6': landingV6Ja
      }
    },
    lng: detectLanguage(), // Set initial language
    fallbackLng: 'ja',
    ns: ['translation', 'landing-v2', 'landing-v3', 'landing-v4', 'landing-v5', 'landing-v6'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
